import {
  Button,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import api from "../../../../components/services/api";
import ReplayIcon from "@mui/icons-material/Replay";
import { Formik } from "formik";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useHistory, useParams } from "react-router";
import moment from "moment";
const organizeData = (data) => {
  const result = [];

  // สร้าง mapping สำหรับการอ้างอิง TagErrorId
  const tagErrorMap = {};
  data.forEach((item) => {
    tagErrorMap[item.TagErrorId] = item;
  });

  data.forEach((item) => {
    if (item.RefTagId) {
      // หากมี RefTagId ให้ไปใส่ใน children ของ TagErrorId ที่อ้างถึง
      if (tagErrorMap[item.RefTagId]) {
        const parent = tagErrorMap[item.RefTagId];
        parent.children = parent.children || [];

        // ตรวจสอบว่าข้อมูลนี้ยังไม่ถูกเพิ่มใน children
        if (
          !parent.children.some((child) => child.TagErrorId === item.TagErrorId)
        ) {
          parent.children.push(item);
        }
      }
    } else {
      // หากไม่มี RefTagId ให้เพิ่มเป็น root node
      result.push(item);
    }
  });

  // จัดเรียง children และ root node จากล่างขึ้นบน
  result.forEach((item) => {
    if (item.children) {
      item.children.sort(
        (a, b) => new Date(b.CreateDate) - new Date(a.CreateDate)
      );
    }
  });

  return result.sort((a, b) => new Date(b.CreateDate) - new Date(a.CreateDate));
};
export default function TagError({ SaleorderData, setValue }) {
  const history = useHistory();
  const { id } = useParams();
  const [TagErrorData, setTagErrorData] = useState([]);
  const [refTagErrorId, setRefTagErrorID] = useState(null);
  const EmpId = localStorage.getItem("EmpId");
  const structuredData = organizeData(TagErrorData);

  const GetTagError = async () => {
    try {
      const data = await api.get(`api/saleorder/detail/tagerror/${id}`);
      // console.log(data.data);
      setTagErrorData(data.data);
    } catch (e) {
      console.log(e);
    }

    //   console.log(customer_id);
  };

  useEffect(() => {
    GetTagError();
  }, []);
  console.log(structuredData);
  return (
    <>
      <h5 style={{ marginTop: "10px" }} className="textcolordarkblue">
        Tag Error
      </h5>
      <div style={{ marginTop: 10, display: "flex" }}>
        {TagErrorData.length > 0 ? (
          <div>
            {structuredData.map((item) => (
              <div key={item.TagErrorId} style={{ marginBottom: "20px" }}>
                {item.children && (
                  <div style={{ marginLeft: "20px", marginTop: "10px" }}>
                    {item.children.map((child) => (
                      <Card
                        key={child.TagErrorId}
                        sx={{
                          minWidth: 400,
                          marginRight: 5,
                          marginLeft: 3,
                          marginTop: 2,
                          marginBottom: 2,
                        }}
                      >
                        <CardContent>{child.Remark}</CardContent>
                        <CardActions disableSpacing>
                          {`${moment(child?.CreateDate).format(
                            "DD/MM/yyyy"
                          )} โดย ${child?.EmployeeName}`}
                        </CardActions>
                      </Card>
                    ))}
                  </div>
                )}
                <Card sx={{ minWidth: 400, marginRight: 5 }}>
                  <ReplayIcon
                    sx={{
                      float: "right",
                      margin: 5,
                      cursor: "pointer",
                      transition: ".3s",
                      ":hover": {
                        transform: "rotate(0.5turn)",
                      },
                    }}
                    onClick={() => {
                      setRefTagErrorID(item.TagErrorId);
                    }}
                  />
                  <CardContent>{item.Remark}</CardContent>
                  <CardActions disableSpacing>
                    {`${moment(item?.CreateDate).format("DD/MM/yyyy")} โดย ${
                      item?.EmployeeName
                    }`}
                  </CardActions>
                </Card>
              </div>
            ))}
            {/* {TagErrorData.map((data, index) => {
              return !data.RefTagId ? (
                <div>
                  <Card sx={{ minWidth: 400, marginRight: 5 }}>
                    <ReplayIcon
                      sx={{
                        float: "right",
                        margin: 5,
                        cursor: "pointer",
                        transition: ".3s",
                        ":hover": {
                          transform: "rotate(0.5turn)",
                        },
                      }}
                      onClick={() => {
                        setRefTagErrorID(data.TagErrorId);
                      }}
                    />
                    <CardContent>{data.Remark}</CardContent>
                    <CardActions disableSpacing>
                      {`${moment(data?.CreateDate).format("DD/MM/yyyy")} โดย ${
                        data?.EmployeeName
                      }`}
                    </CardActions>
                  </Card>
                </div>
              ) : (
                <Card
                  sx={{
                    minWidth: 400,
                    marginRight: 5,
                    marginLeft: 3,
                    marginTop: 2,
                    marginBottom: 2,
                  }}
                >
                  <CardContent>{data.Remark}</CardContent>
                  <CardActions disableSpacing>
                    {`${moment(data?.CreateDate).format("DD/MM/yyyy")} โดย ${
                      data?.EmployeeName
                    }`}
                  </CardActions>
                </Card>
              );
            })} */}
          </div>
        ) : null}

        <Formik
          enableReinitialize
          initialValues={{ status: 1, remark: "" }}
          validate={(values) => {
            const errors = {};
            return errors;
          }}
          onSubmit={(values, { setSubmitting, setFieldValue }) => {
            setTimeout(() => {
              const data = {
                // refTagId: refTagErrorId,
                // remark: values.remark,
                SaleOrderId: id,
                // status: values.status,
                // createId: EmpId,
                TagErrorId: null,
                RefTagId: refTagErrorId,
                Remark: values.remark,
                Level: values.status,
              };

              // console.log(data);

              api
                .post("api/saleorder/update/tagerror", data)
                .then((respose) => {
                  const MySwal = withReactContent(Swal);

                  MySwal.fire({
                    icon: "success",
                    didOpen: () => {
                      MySwal.clickConfirm();
                    },
                  }).then(() => {
                    return MySwal.fire(
                      "สำเร็จ!",
                      "เพิ่ม Tag Error สำเร็จ !",
                      "success"
                    ).then((result) => {
                      if (result.isConfirmed) {
                        setFieldValue("remark", "");
                        // setValue("5");
                        GetTagError();
                      }
                    });
                  });
                })
                .catch((err) => {
                  console.log(err);
                });
              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit}>
              {refTagErrorId ? (
                <div style={{ display: "flex", marginBottom: 10 }}>
                  <TextField
                    sx={{ mr: "5px" }}
                    fullWidth
                    label="รหัสอ้างอิงตอบกลับ"
                    variant="outlined"
                    value={refTagErrorId}
                    disabled
                  />
                  <Button
                    type="button"
                    variant="contained"
                    style={{
                      color: "white",
                      borderColor: "white",
                      backgroundColor: "#E74C3C",
                      marginBottom: 10,
                    }}
                    onClick={() => {
                      setRefTagErrorID("");
                    }}
                  >
                    ลบ
                  </Button>
                </div>
              ) : null}
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  name="status"
                  value={values.status}
                  label="Status"
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  <MenuItem value={1}>High Priority</MenuItem>
                  <MenuItem value={0}>Low Priority</MenuItem>
                </Select>
              </FormControl>
              <TextField
                style={{ marginTop: 10 }}
                rows={3}
                multiline
                fullWidth
                required
                name="remark"
                label="Remark"
                variant="outlined"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.remark}
              />
              <div style={{ display: "flex", marginTop: 10 }}>
                <Button
                  type="button"
                  variant="outlined"
                  style={{
                    color: "#80c340",
                    borderColor: "#80c340",
                    marginRight: "10px",
                  }}
                  onClick={history.goBack}
                >
                  back
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  style={{
                    background: "#80c340",
                    borderColor: "#80c340",
                    marginRight: "10px",
                  }}
                  disabled={isSubmitting}
                >
                  {isSubmitting && <CircularProgress size={22} />}
                  {!isSubmitting && "SAVE"}
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </>
  );
}
